import { extendTheme, getDefaultTheme } from './utils';
const theme = getDefaultTheme();

export { theme, extendTheme };
